@if (digitalSignaturesEnabled) {
    <section class="card">
        <header>
            <h3>Digital signatures</h3>
        </header>
        <div class="card-content notes-v2">
            <div class="signature-list">
                @for (signature of digitalSignatures(); track signature.shareId) {
                    <div class="signature-card">
                        <div class="signature-details">
                            @if (signature.shareTypeReference; as reference) {
                                <div class="bx-base-table-row">
                                    <p class="bold">{{ 'general.variation' | translate }}</p>
                                    <a
                                        class="digital-signature-view-variation"
                                        (click)="
                                            onViewReference.emit({
                                                id: reference.iD_Variation,
                                                type: reference.__typename,
                                            })
                                        "
                                        class="prop-value">
                                        ({{ reference.variationNo }}) {{ reference.description }}
                                    </a>
                                </div>
                            }

                            <div class="bx-base-table-row">
                                <p class="bold">Sent at</p>
                                <p class="prop-value">{{ signature.createdAt | date: dateTimeFormat }}</p>
                            </div>
                            <div class="bx-base-table-row">
                                <p class="bold">Signed at</p>
                                <p class="prop-value">{{ signature.digitalSignature?.signedAt | date: dateTimeFormat }}</p>
                            </div>
                            <div class="bx-base-table-row">
                                <p class="bold">Email address</p>
                                <p class="prop-value">{{ signature.digitalSignature?.approver?.email }}</p>
                            </div>
                        </div>
                        <button
                            class="btn-bx-secondary-stroked digital-signature-view-signed-quote"
                            (click)="showSignature(signature.shareId, signature.referenceType!)">
                            @if (signature.type === 'QUOTE') {
                                <i class="fa-light fa-file-signature"></i> View signed quote
                            } @else if (signature.type === 'VARIATION') {
                                <i class="fa-light fa-file-signature"></i> View signed {{ 'general.variation' | translate | lowercase }}
                            }
                        </button>
                    </div>
                }
            </div>
            @if (hasNextPage() !== false && !hasError()) {
                <div #loading visibilityObserver (onVisible)="loadNext$.next()">
                    <p>Loading...</p>
                </div>
            }
            @if (digitalSignatures()?.length === 0) {
                <div class="empty-state">
                    <h2 class="header-title">No {{ localizedKind() }} signed</h2>
                    <p>Once a {{ localizedKind() }} is digitally signed, it will be shown here</p>
                </div>
            }
        </div>
    </section>
}
